
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import AddAppointment from './_autogen/AddAppointment';
import AddNote from './_autogen/AddNote';
import Add from './_autogen/Add';
import Allergies from './_autogen/Allergies';
import ArrowDown from './_autogen/ArrowDown';
import ArrowUp from './_autogen/ArrowUp';
import Attachment from './_autogen/Attachment';
import Attention from './_autogen/Attention';
import Calendar from './_autogen/Calendar';
import Chart from './_autogen/Chart';
import Close from './_autogen/Close';
import Collapse from './_autogen/Collapse';
import Critical from './_autogen/Critical';
import Delete from './_autogen/Delete';
import DiagnosisProblems from './_autogen/DiagnosisProblems';
import Document from './_autogen/Document';
import Download from './_autogen/Download';
import Drag from './_autogen/Drag';
import Edit from './_autogen/Edit';
import Expand from './_autogen/Expand';
import Export from './_autogen/Export';
import Filter from './_autogen/Filter';
import Flag from './_autogen/Flag';
import Flowsheet from './_autogen/Flowsheet';
import Grid from './_autogen/Grid';
import Help from './_autogen/Help';
import Hide from './_autogen/Hide';
import Home from './_autogen/Home';
import Image from './_autogen/Image';
import Info from './_autogen/Info';
import LabResults from './_autogen/LabResults';
import LeftPanel from './_autogen/LeftPanel';
import Left from './_autogen/Left';
import List from './_autogen/List';
import Mail from './_autogen/Mail';
import Map from './_autogen/Map';
import Medication from './_autogen/Medication';
import Menu from './_autogen/Menu';
import Message from './_autogen/Message';
import ModalPopup from './_autogen/ModalPopup';
import MoreOptions from './_autogen/MoreOptions';
import NavigateAway from './_autogen/NavigateAway';
import NotAllowed from './_autogen/NotAllowed';
import Patient from './_autogen/Patient';
import PaymentMethods from './_autogen/PaymentMethods';
import Pharmacy from './_autogen/Pharmacy';
import PhoneDevice from './_autogen/PhoneDevice';
import Phone from './_autogen/Phone';
import Pin from './_autogen/Pin';
import Print from './_autogen/Print';
import Provider from './_autogen/Provider';
import Quality from './_autogen/Quality';
import Receipt from './_autogen/Receipt';
import Refresh from './_autogen/Refresh';
import RightPanel from './_autogen/RightPanel';
import Right from './_autogen/Right';
import Search from './_autogen/Search';
import Settings from './_autogen/Settings';
import Share from './_autogen/Share';
import Show from './_autogen/Show';
import Success from './_autogen/Success';
import SwitchView from './_autogen/SwitchView';
import Team from './_autogen/Team';
import Time from './_autogen/Time';
import Translation from './_autogen/Translation';
import Upload from './_autogen/Upload';
import Vaccine from './_autogen/Vaccine';
import Vitals from './_autogen/Vitals';
import XRay from './_autogen/XRay';
const ForgeIcons = {
  AddAppointment,
  AddNote,
  Add,
  Allergies,
  ArrowDown,
  ArrowUp,
  Attachment,
  Attention,
  Calendar,
  Chart,
  Close,
  Collapse,
  Critical,
  Delete,
  DiagnosisProblems,
  Document,
  Download,
  Drag,
  Edit,
  Expand,
  Export,
  Filter,
  Flag,
  Flowsheet,
  Grid,
  Help,
  Hide,
  Home,
  Image,
  Info,
  LabResults,
  LeftPanel,
  Left,
  List,
  Mail,
  Map,
  Medication,
  Menu,
  Message,
  ModalPopup,
  MoreOptions,
  NavigateAway,
  NotAllowed,
  Patient,
  PaymentMethods,
  Pharmacy,
  PhoneDevice,
  Phone,
  Pin,
  Print,
  Provider,
  Quality,
  Receipt,
  Refresh,
  RightPanel,
  Right,
  Search,
  Settings,
  Share,
  Show,
  Success,
  SwitchView,
  Team,
  Time,
  Translation,
  Upload,
  Vaccine,
  Vitals,
  XRay,
};

export default ForgeIcons;
